import { DEFAULT_LANGUAGE, LocalizedPage, SupportedLanguage } from './language.types';
import site from '../seo/site.json';

export function localizedPath(page: LocalizedPage, language: SupportedLanguage = DEFAULT_LANGUAGE): string {
  const entry = site.pages.find(entry => entry.id === page)!;
  return language === 'en' ? entry.enPath : entry.path;
}

export function languageFromUrl(url: string): SupportedLanguage {
  const firstSegment = url.split(/[?#]/)[0].split('/').filter(Boolean)[0];
  return firstSegment === 'en' ? 'en' : DEFAULT_LANGUAGE;
}

export function pageFromUrl(url: string): LocalizedPage | null {
  const path = url.split(/[?#]/)[0].replace(/\/$/, '') || '/';
  return (site.pages.find(page => page.path === path || page.enPath === path)?.id as LocalizedPage | undefined) ?? null;
}
